import { useLocation } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

import { OfferErrorType } from '../types';
import { useOfferRouteParams } from './useOfferRouteParams';

export function useErrorPaths(): Record<OfferErrorType, string> {
    const location = useLocation();
    const { orderId, orderRoleId } = useOfferRouteParams();

    return {
        deprecated: `${ APP_ROUTES.candidateOffers }/${ orderId }/${ orderRoleId }/not_found${ location.search }`,
        general: `${ APP_ROUTES.candidateOffers }/${ orderId }/${ orderRoleId }/error${ location.search }`
    };
}
